import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatagridService, PagedResultGeneric, PagedSearch } from 'src/app/shared';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { PostTransactionSummaryDto } from '../../shared/dto/post-transaction-summary.dto';
import { PostTransactionSummaryOptionsDto } from '../../shared/dto/unposted-transaction-summary-options.dto';
import { AccountingPackageService } from '../../shared/accounting-package/accounting-package.service';
import { AccountingPackage } from '../../shared/accounting-package/accounting-package.model';

@Component({
  selector: 'wl-post-transactions-summary',
  templateUrl: './post-transactions-summary.component.html',
  styleUrls: ['./post-transactions-summary.component.less'],
    standalone: false
})
export class PostTransactionsSummaryComponent extends LazySelectableTableComponent<PagedSearch, PostTransactionSummaryDto> {
  @Input() set transactionSummaries(value: Array<PostTransactionSummaryDto>) {
    this._transactionSummaries = value;
    this.summariesChanged();
  }
  @Input() accountingPackageId: number;
  @Input() exportingDetails: boolean;
  @Input() exportingSummaries: boolean;
  @Output() exportSummariesClicked = new EventEmitter();
  @Output() exportDetailsClicked = new EventEmitter();

  private _transactionSummaries: Array<PostTransactionSummaryDto>;
  hideShowAll: boolean = false;
  hideClassColumn: boolean = true;
  hideIntacctColumns: boolean = true;
  totalDebit: number = 0;
  totalCredit: number = 0;

  constructor(datagridService: DatagridService, private _accountingPackageService: AccountingPackageService) {
    super('id', datagridService);
    this.searchResult = { PageSize: 10, CurrentPageNumber: 1 } as PagedResultGeneric<PostTransactionSummaryDto>;
    this.searchParams = { PageNumber: 1, PageSize: 10 } as PagedSearch;
  }

  summariesChanged() {
    this.searchResult.CurrentPageNumber = 1;
    this.searchResult.Result = this._transactionSummaries.slice(0, 10);
    this.search();
    this.configureSummaryGridColumns();
  }

  fetchResults(): Promise<PagedResultGeneric<any>> {
    let showAll = this.searchParams.PageSize == 999999 ? true : false;
    const currentPageNum = this.searchParams.PageNumber - 1;
    let result = [];

    if (this.searchParams.OrderBy) {
      let orderByStrings = this.searchParams.OrderBy.split(':');
      let sortedProperty = orderByStrings[0];
      let sortOrder = orderByStrings[1];
      this._transactionSummaries.sort((a, b) => {
        if (a[sortedProperty] > b[sortedProperty]) {
          return sortOrder == 'asc' ? 1 : -1;
        }
        if (a[sortedProperty] < b[sortedProperty]) {
          return sortOrder == 'asc' ? -1 : 1;
        }
        return 0;
      });
    }

    // we have all the summaries so we're faking paging
    if (!showAll) {
      if (currentPageNum == 0) {
        result = this._transactionSummaries.slice(0, 10);
      } else {
        result = this._transactionSummaries.slice(currentPageNum * 10 + 1, currentPageNum * 10 + 10);
      }
    } else {
      result = this._transactionSummaries;
    }

    this.totalCredit = this._transactionSummaries.reduce((x, y) => x + y.CreditAmount, 0);
    this.totalDebit = this._transactionSummaries.reduce((x, y) => x + y.DebitAmount, 0);

    return Promise.resolve({
      PageSize: showAll ? 999999 : 10,
      CurrentPageNumber: showAll ? 1 : this.searchParams.PageNumber,
      TotalCount: this._transactionSummaries.length,
      TotalPages: showAll ? 1 : ((this._transactionSummaries.length / 10) | 0) + 1,
      Result: result,
    } as PagedResultGeneric<any>);
  }

  showAll() {
    this.hideShowAll = true;
    this.searchParams.PageSize = 999999;
    this.search();
  }

  exportSummaries() {
    this.exportSummariesClicked.emit(null);
  }

  exportDetails() {
    this.exportDetailsClicked.emit(null);
  }

  configureSummaryGridColumns() {
    this._accountingPackageService.get(this.accountingPackageId).then((accountingPackage: AccountingPackage) => {
      accountingPackage.PackageType != 1 && accountingPackage.PackageType != 4 ? (this.hideClassColumn = true) : (this.hideClassColumn = false);
      accountingPackage.PackageType != 3 ? (this.hideIntacctColumns = true) : (this.hideIntacctColumns = false);
    });
  }
}
